import { IUserPreference as IUserPreferenceSchema } from "@findemdev/findem-types";
import { ACLS } from "../constants/acls";
import { IUser } from "../types/users";
import { AppName } from "../types/app";

export const FINDEM_EMAIL_DOMAIN = "@findem.ai";
export const RRA_EMAIL_DOMAIN = "@russellreynolds.com";

export const isRRAEmailAddress = (email: string | undefined) =>
  Boolean(email?.trim().toLowerCase().endsWith(RRA_EMAIL_DOMAIN));

export interface IUserPreference extends IUserPreferenceSchema {
  apps: string[];
}
export interface IUserModel extends IUser {
  userPreference?: IUserPreference;
  appName: AppName;
}

// @malli to do typedef for this user model
export class UserModel {
  private user: IUserModel;

  constructor(user: IUserModel) {
    this.user = user;
  }

  public getUser() {
    return this.user;
  }

  public isAdminUser() {
    return this.user.roles.includes(ACLS.ADMIN_ACL);
  }

  public isOracleUser() {
    return this.user.roles.includes(ACLS.ORACLE_ACL);
  }

  public isAgenticInternalAdmin() {
    return this.user.roles.includes(ACLS.AGENTIC_INTERNAL_ADMIN);
  }

  public canImpersonate() {
    return this.isAgenticInternalAdmin();
  }

  public canAccessRaasInternalPortal() {
    return this.isFindemUser();
  }

  public isFindemUser() {
    return this.user.email.endsWith(FINDEM_EMAIL_DOMAIN);
  }

  public isRRAUser() {
    return isRRAEmailAddress(this.user.email);
  }

  public isCredAdmin() {
    return this.user.roles.includes(ACLS.FM_CRED_ADMIN_ACL);
  }

  public isTestRRAUser() {
    return this.isRRAUser() && this.user.email.includes("test");
  }

  public updateUser(user: IUserModel) {
    this.user = user;
  }

  public getUserPreference() {
    return this.user.userPreference;
  }

  public setUserPreference(userPreference: IUserPreference) {
    this.user.userPreference = userPreference;
  }

  public getAppName() {
    return this.user.appName;
  }

  public hasGetroNetwork(): boolean {
    return !!this.user.getro_network_id;
  }

  public getEffectiveJoid(targetUserId: string | null | undefined): string {
    return targetUserId || this.user.uid;
  }

  public getEffectiveAccountId(
    targetUserId: string | null | undefined,
    allUsers?: { users: Array<{ _id: string; account_id?: string }> }
  ): string {
    if (targetUserId && allUsers?.users) {
      const impersonatedUser = allUsers.users.find((user) => user._id === targetUserId);
      if (impersonatedUser?.account_id) {
        return impersonatedUser.account_id;
      }
    }
    return this.user.account_id;
  }
}
